window.rtlDefinition = {
  width: {
    // used during the calculation of the input sizes for textbox and dropdownbox and label
    inputbox: {
      hasPopup: 24,
      labelOffset: {
        singleLine: 16
      }
    }
  }
};
